import { dataSourcesStardogRequestDispatchers } from 'src/actions/data-sources/actionCreators';
import { isStardogFeatureSupportedSelector } from 'src/selectors/isStardogFeatureSupported';
import { AppDispatch } from 'src/store/store';
import { ReduxStateGetter } from 'src/store/types';

export const refreshDataSourceTables =
  (dataSourceId: string) =>
  async (_: AppDispatch, getState: ReduxStateGetter) => {
    const state = getState();
    const { connection } = state.connections;
    if (!connection) {
      return;
    }

    const isCatalogSupported = isStardogFeatureSupportedSelector(
      'isCatalogSupported',
      connection
    )(state);

    const isDataSourceTablesEndpointSupported =
      isStardogFeatureSupportedSelector(
        'isDataSourceTablesEndpointSupported',
        connection
      )(state);

    await dataSourcesStardogRequestDispatchers.requestDataSourceInfo(
      dataSourceId
    );
    if (!isDataSourceTablesEndpointSupported) {
      await dataSourcesStardogRequestDispatchers.requestDataSourceTableMetadata(
        dataSourceId,
        isCatalogSupported
      );
    } else {
      await dataSourcesStardogRequestDispatchers.requestDataSourceTables(
        dataSourceId,
        isCatalogSupported
      );
    }
  };
